import React from 'react'
import {
    FaUser,
    FaGraduationCap,
    FaBriefcase,
    FaRegFileAlt,
    FaPaperPlane
} from 'react-icons/fa';

import { AiFillHome } from "react-icons/ai";
import { useNavigate } from 'react-router-dom';
// import { FormContext } from './Provider';



export default function Progress({ step, Auth }) {

    const navigate = useNavigate()
    console.log("Auth:", Auth); // Debug line
    console.log({ FaUser, FaGraduationCap, FaBriefcase, FaRegFileAlt, FaPaperPlane });
    const icons = Auth === false ? [FaUser, FaGraduationCap, FaBriefcase, FaRegFileAlt, FaPaperPlane] : [FaUser, FaGraduationCap, FaBriefcase, FaRegFileAlt];
    const stepperInfo = Auth === false ? ["Personal Info", "Academic Info", "Employement", "Registration", "submit"] :
        ["Personal Info", "Academic Info", "Employement", "Registration"];




    console.log("step:", step); // Debug line
    return (

        <div className="container mx-auto mt-6 md:px-4">

            {/* Responsive Layout */}


            {/* Mobile: vertical flex layout */}
            {/* Mobile View Only */}
            <div className="flex flex-col md:hidden px-4">
                {/* Progress Icons - Horizontal Row */}
                <div className="flex justify-center gap-4 mb-4">
                    {icons.map((Icon, i) => (
                        <div
                            key={i}
                            className={`w-10 h-10 flex items-center justify-center rounded-full border-2 transition-all duration-300 cursor-pointer
          ${step === i
                                    ? 'bg-white text-blue-600 border-blue-600 shadow-md'
                                    : i < step
                                        ? 'bg-blue-500 text-white border-blue-500'
                                        : 'bg-gray-300 text-white border-gray-300'
                                }`}
                        >
                            <Icon className="w-4 h-4" />

                        </div>
                    ))}

                    {
                        Auth === false ? '' : <AiFillHome className='w-9 h-9  bg-white text-blue-600 border-blue-600 border-2 p-1 rounded-full '
                            onClick={() => navigate('/admin/dashboard')} />
                    }

                </div>

                {/* Form Rendered Below Icons */}

            </div>


            {/* Desktop: horizontal layout */}

            <div className="hidden md:block ">
                <ul className="flex items-center justify-between gap-4">
                    {stepperInfo.map((label, i) => {
                        const Icon = icons[i];
                        return (
                            <React.Fragment key={i}>
                                <li
                                    className="flex flex-col items-center cursor-pointer"

                                >
                                    <span
                                        className={`w-10 h-10 flex items-center justify-center rounded-full border-2
                        ${step === i
                                                ? 'bg-white text-blue-600 border-blue-600 shadow-md'
                                                : i < step
                                                    ? 'bg-blue-500 text-white border-blue-500'
                                                    : 'bg-gray-300 text-white border-gray-300'
                                            }`}
                                    >
                                        <Icon className="w-4 h-4" />
                                    </span>
                                    <span className="mt-2 text-sm text-black font-medium">{label}</span>


                                </li>



                                {/* Line */}
                                {i < stepperInfo.length - 1 && (
                                    <div className="hidden md:flex items-center flex-1 px-2">
                                        <div className="w-full h-1 bg-white rounded-full relative overflow-hidden">
                                            <div
                                                className={`h-1 rounded-full bg-blue-600 transition-all duration-500 ease-in-out`}
                                                style={{
                                                    width: `${step > i ? 100 : 0}%`
                                                }}
                                            ></div>
                                        </div>

                                    </div>
                                )}
                            </React.Fragment>
                        );
                    })}
                    {
                        Auth === false ? '' : <AiFillHome className='w-9 h-9 bg-white text-blue-600 border-blue-600 border-2 p-1 rounded-full translate-x-3 translate-y-14'
                            onClick={() => navigate('/admin/dashboard')} />

                    }
                </ul>

                {/* Form below in desktop */}
                {/* <div className="mt-6">{renderFormStep()}</div> */}


            </div>

        </div>
    );
};

